var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.6736,
    r: 12,
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1202 18.1181H6.88128C6.51684 18.1181 6.20489 17.8576 6.1419 17.5017L5.01107 11.0502C4.96457 10.7837 5.06656 10.5127 5.27953 10.343C5.49249 10.1732 5.78045 10.13 6.03391 10.2343L9.09944 11.4775L11.3491 7.57654C11.6161 7.11348 12.3824 7.11348 12.6509 7.57654L14.9006 11.4775L17.9661 10.2343C18.2196 10.1315 18.5075 10.1732 18.7205 10.343C18.9334 10.5127 19.0354 10.7837 18.9889 11.0502L17.8581 17.5017C17.7966 17.8576 17.4847 18.1181 17.1202 18.1181Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12,
    y1: 24.6736,
    x2: 12,
    y2: 0.673584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE55F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.673584)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumIcon);
export default __webpack_public_path__ + "static/media/premium_icon.71b44bfb29a46b49cf7637b65703d0ef.svg";
export { ForwardRef as ReactComponent };